import { render, staticRenderFns } from "./ContributionsTable.html?vue&type=template&id=bb7908a4&"
import script from "./ContributionsTable.component.js?vue&type=script&lang=js&"
export * from "./ContributionsTable.component.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports